/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/blog/grid.js":
/*!********************************************!*\
  !*** ./zrc/scripts/templates/blog/grid.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! hequalizer */ \"./node_modules/hequalizer/hequalizer.min.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hequalizer__WEBPACK_IMPORTED_MODULE_0__);\n\nclass BlogGrid extends window.HTMLElement {\n  connectedCallback() {\n    this.container = this;\n    this.init();\n  }\n  init() {\n    this.setElementsHeight();\n  }\n  setElementsHeight() {\n    const $tags = this.container.querySelectorAll('.article-card-tag');\n    const $titles = this.container.querySelectorAll('.article-card-title-wrapper');\n    const $excerpts = this.container.querySelectorAll('.article-card-excerpt-wrapper');\n    const options = {\n      cssVariable: '--height',\n      columns: 3,\n      responsive: {\n        // window.innerWidth <= 834\n        834: {\n          columns: 1\n        }\n      }\n    };\n    this.cardDateCalculation = new (hequalizer__WEBPACK_IMPORTED_MODULE_0___default())($tags, options);\n    this.cardTitleCalculation = new (hequalizer__WEBPACK_IMPORTED_MODULE_0___default())($titles, options);\n    this.cardExcerptCalculation = new (hequalizer__WEBPACK_IMPORTED_MODULE_0___default())($excerpts, options);\n  }\n}\nif (window.customElements.get('blog-grid') == null) {\n  window.customElements.define('blog-grid', BlogGrid);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi96cmMvc2NyaXB0cy90ZW1wbGF0ZXMvYmxvZy9ncmlkLmpzLmpzIiwic291cmNlcyI6WyJ3ZWJwYWNrOi8vZ2V0bW9yZS13b3JrZmxvdy8uL3pyYy9zY3JpcHRzL3RlbXBsYXRlcy9ibG9nL2dyaWQuanM/OTdiMSJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgSGVxdWFsaXplciBmcm9tIFwiaGVxdWFsaXplclwiO1xuXG5jbGFzcyBCbG9nR3JpZCBleHRlbmRzIHdpbmRvdy5IVE1MRWxlbWVudCB7XG5cbiAgY29ubmVjdGVkQ2FsbGJhY2soKSB7XG4gICAgdGhpcy5jb250YWluZXIgPSB0aGlzO1xuICAgIHRoaXMuaW5pdCgpO1xuICB9XG5cbiAgaW5pdCgpIHtcbiAgICB0aGlzLnNldEVsZW1lbnRzSGVpZ2h0KCk7XG4gIH1cblxuICBzZXRFbGVtZW50c0hlaWdodCgpIHtcbiAgICBjb25zdCAkdGFncyA9IHRoaXMuY29udGFpbmVyLnF1ZXJ5U2VsZWN0b3JBbGwoJy5hcnRpY2xlLWNhcmQtdGFnJyk7XG4gICAgY29uc3QgJHRpdGxlcyA9IHRoaXMuY29udGFpbmVyLnF1ZXJ5U2VsZWN0b3JBbGwoJy5hcnRpY2xlLWNhcmQtdGl0bGUtd3JhcHBlcicpO1xuICAgIGNvbnN0ICRleGNlcnB0cyA9IHRoaXMuY29udGFpbmVyLnF1ZXJ5U2VsZWN0b3JBbGwoJy5hcnRpY2xlLWNhcmQtZXhjZXJwdC13cmFwcGVyJyk7XG4gICAgY29uc3Qgb3B0aW9ucyA9IHtcbiAgICAgIGNzc1ZhcmlhYmxlOiAnLS1oZWlnaHQnLFxuICAgICAgY29sdW1uczogMyxcbiAgICAgIHJlc3BvbnNpdmU6IHtcbiAgICAgICAgLy8gd2luZG93LmlubmVyV2lkdGggPD0gODM0XG4gICAgICAgIDgzNDoge1xuICAgICAgICAgIGNvbHVtbnM6IDEsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIH07XG5cbiAgICB0aGlzLmNhcmREYXRlQ2FsY3VsYXRpb24gPSBuZXcgSGVxdWFsaXplcigkdGFncywgb3B0aW9ucyk7XG4gICAgdGhpcy5jYXJkVGl0bGVDYWxjdWxhdGlvbiA9IG5ldyBIZXF1YWxpemVyKCR0aXRsZXMsIG9wdGlvbnMpO1xuICAgIHRoaXMuY2FyZEV4Y2VycHRDYWxjdWxhdGlvbiA9IG5ldyBIZXF1YWxpemVyKCRleGNlcnB0cywgb3B0aW9ucyk7XG4gIH1cbn1cblxuaWYgKHdpbmRvdy5jdXN0b21FbGVtZW50cy5nZXQoJ2Jsb2ctZ3JpZCcpID09IG51bGwpIHtcbiAgd2luZG93LmN1c3RvbUVsZW1lbnRzLmRlZmluZSgnYmxvZy1ncmlkJywgQmxvZ0dyaWQpO1xufSJdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7QUFFQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFFQTtBQUNBO0FBQ0EiLCJzb3VyY2VSb290IjoiIn0=\n//# sourceURL=webpack-internal:///./zrc/scripts/templates/blog/grid.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"blog-grid": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/blog/grid.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;